import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ScrollRestorationService } from './core/services/scroll-restoration.service';
import { TranslationService } from './core/services/translation.service';
import { CookieBannerComponent } from './shared/components/cookie-banner/cookie-banner.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { HeaderComponent } from './shared/components/header/header.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent, CookieBannerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly BASE_TITLE = 'MzmHomes';
  private readonly TITLE_SUFFIX = 'Premium Living, Anywhere You Go';
  private routerSubscription: Subscription | undefined;

  constructor(
    private scrollRestorationService: ScrollRestorationService,
    private translationService: TranslationService,
    private router: Router,
    private titleService: Title
  ) {
    // ScrollRestorationService is injected here to ensure it's instantiated
    // and the navigation subscription is set up
  }

  ngOnInit(): void {
    // Initialize translations
    // The TranslationService will automatically load the appropriate JSON file
    // based on the current language

    // Subscribe to router events to update title
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        let route = this.router.routerState.root;
        let routeTitle = '';

        // Find the last child route with data
        while (route.firstChild) {
          route = route.firstChild;
          if (route.snapshot.data['title']) {
            routeTitle = route.snapshot.data['title'];
          }
        }

        // If we have a specific route title, use it; otherwise use base title
        if (routeTitle) {
          this.titleService.setTitle(
            `${this.BASE_TITLE} - ${routeTitle} - ${this.TITLE_SUFFIX}`
          );
        } else {
          this.titleService.setTitle(
            `${this.BASE_TITLE} - ${this.TITLE_SUFFIX}`
          );
        }
      });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
